import {
  createContext,
  useMemo,
  useReducer,
  useContext,
  useEffect
} from 'react';
import {
  // getEventAllRegistrations,
  getEventUserDetails
} from '@queries/events.queries';
import { Store } from '@utils/store/ContextStore';
// import axios from 'axios';

export const EventDataContext = createContext();

function reducer(state, action) {
  switch (action.type) {
    case 'UPDATE':
      if (action?.payload) {
        const newState = {
          ...state,
          ...action.payload
        };

        return newState;
      }

      return state;

    default:
      return state;
  }
}

export const EventDataContextProvider = ({ children, initialData }) => {
  const [data, dispatch] = useReducer(reducer, initialData);

  const { state } = useContext(Store);
  const user = state.user;

  useEffect(() => {
    const updateEventData = async () => {
      const { data: updatedData } = await getEventUserDetails({
        eventID: initialData.eventID,
        eventTypeID: initialData?.eventTypeID,
        communityID: initialData.communityID,
        accessToken: user.accessToken
      });

      if (updatedData) {
        dispatch({ type: 'UPDATE', payload: updatedData });
      }
    };

    if (user?.accessToken) {
      updateEventData();
    }
  }, [initialData, user]);

  // useEffect(() => {
  //   async function getRegistrationsData(cancelToken) {
  //     const eventRegistrations = await getEventAllRegistrations({
  //       eventID: initialData.eventID,
  //       accessToken: user.accessToken,
  //       cancelToken: cancelToken
  //     });
  //     if (eventRegistrations.data?.length > 0) {
  //       dispatch({
  //         type: 'UPDATE',
  //         payload: { eventRegistrations: eventRegistrations.data }
  //       });
  //     }
  //   }

  //   let source = null;
  //   if (user?.accessToken) {
  //     source = axios.CancelToken.source();
  //     getRegistrationsData(source.token);
  //   }

  //   return () => {
  //     if (source) source.cancel();
  //   };
  // }, [initialData.eventID, user.accessToken]);

  const value = useMemo(() => {
    return {
      data,
      dispatch
    };
  }, [data]);

  return (
    <EventDataContext.Provider value={value}>
      {children}
    </EventDataContext.Provider>
  );
};
